























import { Vue, Component, Prop } from 'vue-property-decorator';
import EditorCell from '@/editor/editor-block-view/components/EditorCell.vue';
import { ICell, IMergeValues } from '@/editor/types';
import { EBlockWidth } from '@/editor/types/enums';

@Component({
  components: {
    EditorCell,
  },
})
export default class EditorRow extends Vue {
  @Prop() cells: ICell[];
  @Prop() mergeValues: IMergeValues;
  @Prop() isPdfViewer: boolean;
  @Prop() blockWidthClass: EBlockWidth;
  @Prop() containsCoverImage: boolean;
  @Prop() pageWidth: number;
  @Prop() isBlockToggled: boolean;
}
